import DOMPurify from 'dompurify';
import { getCookie } from './cookies';
import { getGCLIDValue } from './getGCLIDValue';
import { formatMarketingAttributionValueFromCookie } from './formatMarketingAttributionValueFromCookie';
import { formattedAdditionalCommentsTextarea } from './formattedAdditionalCommentsTextarea';
import optimizerABTestCookieValues from './optimizerABTestCookieValues';

export const formatPostObject = (formikObject: object, optout: boolean, textareaExistsStateVariable: boolean) => {
  const payload: any = formikObject;
  const abTestValues: string = optimizerABTestCookieValues();
  const formattedMarketingAttributionObject: any = formatMarketingAttributionValueFromCookie();
  for (const [key, value] of Object.entries(payload)) {
    switch (key) {
      case 'country':
        payload[key] = value ? value : getCookie('cciso');
        break;
      case 'salesBrief':
        payload[key] = DOMPurify.sanitize(
          formattedAdditionalCommentsTextarea(
            typeof value === 'string' ? value : '',
            typeof payload.textarea === 'string' ? payload.textarea : '',
            textareaExistsStateVariable
          )
        );
        break;
      case 'company':
      case 'phone':
      case 'name':
        payload[key] = value != null ? DOMPurify.sanitize(value.toString(), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }) : value;
        break;
      case '_mkto_trk':
        payload[key] = window._mkto_trk ? window!._mkto_trk : '';
        break;
      case 'chop_id':
        payload[key] = getCookie('chop_id') || '';
        break;
      case 'gclid':
        payload[key] = getGCLIDValue();
        break;
      case 'campaignID':
        payload[key] = value || '';
        break;
      default:
        if (typeof value === 'string') {
          payload[key] = DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        }
        break;
    }
  }

  if (payload.textarea) delete payload.textarea; // marketo requires us to do stuff like this
  return {
    ...payload,
    ...formattedMarketingAttributionObject,
    ...{ optout: optout },
    ...(abTestValues ? { experiment: optimizerABTestCookieValues() } : {}),
  };
};
